import ParameterModel from '../models/ParameterModel';
import BaseStore from './BaseStore';
import { action, computed } from 'mobx';
import _ from 'lodash';

class ParameterStore extends BaseStore {
  tableOptions = [
    {label: 'Observation', value: 0},
    {label: 'Aggregation', value: 1},
    {label: 'Text', value: 2},
    // {label: 'Observation Hourly', value: 3},
    // {label: 'Observation Daily', value: 4},
  ]
  tagStore

  constructor(transportLayer, tagStore) {
    super(ParameterModel, transportLayer);
    this.tagStore = tagStore;
  }

  @computed get itemsWithLabels() {
    return this.items.map(item => ({
      ...item,
      label: `${item.name} (${item.code})`,
    }));
  }

  updateItem(json) {
    const item = this.findById(json.id);
    const payload = {
      code: json.code,
      name: json.name,
      description: json.description,
      parameter_type_id: json.parameter_type_id,
      property: json.property,
      table: json.table,
      interval: json.interval
    };
    return this
      ._update(json.id, payload)
      .then(action(() => {
        item.updateFromJson(json);
      }));
  }

  filterParameters = (parameters, filterText, codeKey = 'code') => {
    let tag = this.tagStore.items.find(item => item.name.toString().toLowerCase() === filterText.toLowerCase());
    if(!!tag) return parameters.filter(item => tag.parameters.map(p => p.id).indexOf(item.id) > -1);
    return parameters.filter(parameter => (
      (_.result(parameter, 'name', '').toString().toLowerCase().indexOf(filterText) !== -1) ||

      (_.result(parameter, codeKey, '').toString().toLowerCase().indexOf(filterText) !== -1)
    ))
  }
}

export default ParameterStore;




// WEBPACK FOOTER //
// ./src/stores/ParameterStore.js